import authInstance from 'config/axios.config';

export const customerServices = {
  getCustomers: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/customer?${params}`);
    return res.data;
  },

  getCustomer: async (customerId) => {
    const res = await authInstance.get(`/admin/customer/${customerId}`);
    return res.data;
  },

  getCustomerStats: async () => {
    const res = await authInstance.get('/admin/customer/stats');
    return res.data;
  },

  getCustomerAddresses: async (customerId) => {
    const res = await authInstance.get(`/admin/customer/${customerId}/addresses`);
    return res.data;
  },

  updateCustomerStatus: async (payload) => {
    const { customerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/customer/${customerId}/status`, data);
    return res.data;
  },

  updateKycStatus: async (payload) => {
    const { customerId, ...data } = payload;
    const res = await authInstance.patch(`/admin/customer/${customerId}/kyc/status`, data);
    return res.data;
  },

  verifyKycDocument: async (payload) => {
    const { customerId, documentId, ...data } = payload;
    const res = await authInstance.patch(`/admin/customer/${customerId}/kyc/document/${documentId}`, data);
    return res.data;
  },

  exportCustomers: async ({
  search,
  status,
  kycStatus,
  phoneVerified,
  emailVerified,
  sortBy,
  order,
}) => {
  const params =
    new URLSearchParams({
      search:
        search || '',

      status:
        status || '',

      kycStatus:
        kycStatus || '',

      phoneVerified:
        phoneVerified || '',

      emailVerified:
        emailVerified || '',

      sortBy:
        sortBy || 'createdAt',

      order:
        order || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/admin/customer/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
